import React from "react";
import { NavLink } from "react-router-dom";
import profile from "../../assets/image/profile.jpeg";

function About() {
    return (
        <>
            <section
                className="section about-content bg-light-about bg-light"
                id="about"
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-heading mb-5">
                                <h3 className="text-dark mb-1 fw-light text-uppercase">
                                    About Us
                                </h3>
                                <div className="title-border-simple position-relative"></div>
                            </div>
                        </div>
                    </div>
                    <div className="align-items-center mt-5 row">
                        <div className="col-md-6">
                            <div className="about-desc">
                                <h3 className="text-dark mb-3 fw-light">
                                    Tentang Kami Manggala Pustaka
                                </h3>
                                <p className="text-muted f-15 text-hidden">
                                    Taman Baca Masyarakat Manggala pustaka
                                    merupakan satu-satu nya Taman baca yang ada
                                    di desa Simo, Tepatnya di dukuh Manggal Rt
                                    17/rw 06. Kecamatan Simo, Kabupaten
                                    Boyolali. Perpustakaan Manggala Pustaka
                                    merupakan gagasan dari masyarakat di dukuh
                                    Manggal terutama para pemuda-pemudi desa.
                                    TBM sendiri bergerak dibidang khususnya
                                    anak-anak. Adapun kegiatan dri TBM antara
                                    lain seperti kelas mewarnai, kelas mengaji,
                                    kelas memanah kelas kesenian, serta kelas
                                    darurat yang di adakan pda saat anak-anak
                                    sekolah online, tak hanya dibagian anak saja
                                    kegiatan yang mengarah ke masyarakat seperti
                                    pengecekan kesehatan, diskusi tentang
                                    pertanian modern serta kegiatan positif
                                    lainnya guna untuk meningkatkan perekonomian
                                    dan pemberdayaan masyarakat
                                </p>
                                <div className="about-by">
                                    <p className="fw-light mb-0">
                                        <NavLink
                                            className="text-dark"
                                            to="/About"
                                        >
                                            Learn More
                                            <span className="text-custom mx-2">
                                                About Us
                                            </span>
                                        </NavLink>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="about-img light-img position-relative p-4">
                                <img
                                    src={profile}
                                    alt=""
                                    className="img-fluid mx-auto d-block"
                                ></img>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default About;
